import { CmsApiTwoTilesBlockData } from 'modules/cms/api/types/blocks/CmsApiTwoTilesBlock';
import { CmsAmpSplitContentBlock } from 'modules/cms/blocks/Amp/CmsAmpSplitContentBlock';
import { CmsAmpBlockMappingComponentProps } from 'modules/cms/blocks/CmsBlockMapping';

export function CmsAmpTwoTilesBlock({
  data,
}: CmsAmpBlockMappingComponentProps<CmsApiTwoTilesBlockData>) {
  const buttonOne =
    data.tileOneButtonText && data.tileOneButtonUrl
      ? {
          text: data.tileOneButtonText,
          data: {
            ur: data.tileOneButtonUrl,
          },
        }
      : null;

  const buttonTwo =
    data.tileTwoButtonText && data.tileTwoButtonUrl
      ? {
          text: data.tileTwoButtonText,
          data: {
            ur: data.tileTwoButtonUrl,
          },
        }
      : null;

  return (
    <CmsAmpSplitContentBlock
      data={{
        sections: [
          {
            type: 'TEXT',
            data: {
              headline: data.tileOneHeadline,
              html: data.tileOneText,
              // @ts-expect-error TS(2322): Type '{ text: string; data: { ur: string; }; } | n... Remove this comment to see the full error message
              button: buttonOne,
            },
          },
          {
            type: 'TEXT',
            data: {
              headline: data.tileOneHeadline,
              html: data.tileOneText,
              // @ts-expect-error TS(2322): Type '{ text: string; data: { ur: string; }; } | n... Remove this comment to see the full error message
              button: buttonTwo,
            },
          },
        ],
      }}
    />
  );
}
